<script lang="ts">
    import {createEventDispatcher, onDestroy, onMount} from "svelte";

    // Рендерить вміст (і, відповідно, запускає завантаження вкладень у ньому) лише коли блок
    // наближається до видимої області. Після першої появи вміст лишається, щоб не вантажити повторно.
    export let rootMargin: string = "300px"
    export let inline: boolean = false

    let element: HTMLElement
    let visible = false
    let observer: IntersectionObserver | null = null
    const dispatch = createEventDispatcher()

    // Подія `visible` — для компонентів, яким треба самим почати завантаження при появі
    $: if (visible) dispatch("visible")

    onMount(() => {
        if (!("IntersectionObserver" in window)) {
            visible = true
            return
        }
        observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                visible = true
                observer?.disconnect()
                observer = null
            }
        }, {rootMargin})
        observer.observe(element)
    })

    onDestroy(() => observer?.disconnect())
</script>

{#if inline}
    <span bind:this={element} style:display="inline-block" style:min-width="1px" style:min-height="1px">{#if visible}<slot/>{/if}</span>
{:else}
    <div bind:this={element} style:min-height="1px">{#if visible}<slot/>{/if}</div>
{/if}
